import React from 'react';
import {
    HistoryContainer,
    Row,
    Icon,
    Status,
    DemiText,
    RegularSmallText,
} from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport.styled';
import MDICheckCircle from 'src/assets/images/MDICheckCircle.svg';
import MDIEmailAlertOutline from 'src/assets/images/MDIEmailAlertOutline.svg';
import MDIEmailRemove from 'src/assets/images/MDIEmailRemove.svg';
import MDIEmailSyncOutline from 'src/assets/images/MDIEmailSyncOutline.svg';
import MDIFaxSuccess from 'src/assets/images/MDIFaxSuccess.svg';
import MDIFaxSending from 'src/assets/images/MDIFaxSending.svg';
import MDIFaxPending from 'src/assets/images/MDIFaxPending.svg';
import MDIFaxFailed from 'src/assets/images/MDIFaxFailed.svg';
import { getDisplayDate } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';

const ReportHistory = (props) => {
    const selectPicture = (status) => {
        switch (status) {
            case 'Pending':
                return props.isEmail ? MDIEmailAlertOutline : MDIFaxPending;
            case 'Success':
                return props.isEmail ? MDICheckCircle : MDIFaxSuccess;
            case 'Failed':
                return props.isEmail ? MDIEmailRemove : MDIFaxFailed;
            case 'Sending':
                return props.isEmail ? MDIEmailSyncOutline : MDIFaxSending;
            case 'Resending':
                return MDIEmailSyncOutline;
            default:
                break;
        }
    };
    const { t } = useTranslation();
    return (
        <>
            <HistoryContainer>
                {props.reportHistory?.map((history) => {
                    return (
                        <>
                            <Row padding={'0px 0px 10px 0px'}>
                                <div style={{ margin: '7px' }}>
                                    <Icon
                                        id={`report-history-icon-${history.id}`}
                                        src={selectPicture(history.status)}
                                    ></Icon>
                                </div>

                                <Status>
                                    <DemiText breakWord={'break-all'}>
                                        {history.emailAddress
                                            ? history?.emailAddress
                                            : history?.faxNumber}
                                    </DemiText>
                                    <RegularSmallText>
                                        {history.pricing
                                            ? t('orders.orderStatuses.priceon')
                                            : history?.type === 'DISCREPANCY'
                                            ? t('orders.orderStatuses.Usagediscrepancy')
                                            : t('orders.orderStatuses.priceonwo')}{' '}
                                        {`${
                                            history?.date
                                                ? getDisplayDate(
                                                      history.date,
                                                  )
                                                : ''
                                        } (${
                                            history.status === 'Success'
                                                ? t('orders.orderStatuses.sentsucce')
                                                : history.status
                                        })`}
                                    </RegularSmallText>
                                </Status>
                            </Row>
                        </>
                    );
                })}
            </HistoryContainer>
        </>
    );
};

export default ReportHistory;
